import React from 'react';
import PropTypes from 'prop-types';
import { PostHogProvider } from '@posthog/react';
import posthog from 'posthog-js';
import ServicesOnline from './pages/ServicesOnline';

const isServer = typeof window === 'undefined';

export const App = ({
  serverPages = {}
}) => {
  if (isServer) {
    return <ServicesOnline serverPages={serverPages} />;
  }

  return (
    <PostHogProvider client={posthog}>
      <ServicesOnline serverPages={serverPages} />
    </PostHogProvider>
  );
};

App.propTypes = {
  serverPages: PropTypes.shape({}).isRequired
};
